import React from 'react'
import style from './TableCalendar.css'
import {InputText} from './InputText.jsx'

export const TableCalendar = ({days, onChangeStatusDay, onSaveCommentDay}) => {
    return(
        <table className={`table table-striped ${style.TableCalendar}`}>
            <thead>
                <tr>
                    <th className={style.TableCalendar_thDate}>Fecha</th>
                    <th className={style.TableCalendar_thComment}>Comentario</th>
                    <th className={style.TableCalendar_thBusinessDay}>Laborable</th>
                </tr>
            </thead>
            <tbody>
              {days.map((day) =>
                <tr key = {day.date} className={!day.business_day? style.TableCalendar_trIsNotBusinessDay : ''}>
                    <td>{day.format_date}</td>
                    <td>
                        <InputText
                            day={day}
                            onSaveCommentDay={onSaveCommentDay}
                        />
                    </td>
                    <td className={style.TableCalendar_tdCheckBox}>
                        <input 
                            type="checkbox"
                            className="form-check-input"
                            checked={day.business_day}
                            onChange={(evt) => onChangeStatusDay(day.date, evt)}
                        />
                    </td>
                </tr>
              )}
            </tbody>
        </table>
    )
}


// WEBPACK FOOTER //
// ./frontEnd/admin/CalendarMaintainer/components/TableCalendar.jsx